import { TextFieldProps } from '@forgeglobal/design-framework';
import { MaskitoOptions } from '@maskito/core';
import { FieldRenderProps } from 'react-final-form';
import MaskedTextField from '../MaskedTextField';

const options: MaskitoOptions = {
  mask: [...new Array(5).fill(/\d/), '-', ...new Array(4).fill(/\d/)],
};

const ZipCodeTextField = (
  props: TextFieldProps<any>
): React.ReactElement<FieldRenderProps<any, HTMLInputElement>> => {
  return <MaskedTextField {...props} options={options} />;
};

export default ZipCodeTextField;
